import { ROUTES } from "@/app/routes";
import type { Notification } from "@/domain";

/**
 * Generates navigation link for notification's related entity.
 * Must stay in sync with backend `RelatedEntityType` (domain/notifications/enums.py).
 */
export const getNotificationLink = (notification: Notification): string | null => {
  if (!notification.related_entity_type || !notification.related_entity_uuid) {
    return null;
  }

  const uuid = notification.related_entity_uuid;
  switch (notification.related_entity_type) {
    case "project":
      return ROUTES.PROJECTS.DETAIL(uuid);
    case "beneficiary":
      return ROUTES.BENEFICIARIES.DETAIL(uuid);
    case "investment":
      return `${ROUTES.INVESTMENTS.MAIN}?investment=${uuid}`;
    /**
     * "document" is a legacy alias — contract notifications were stored as
     * "document" before the 2026-05-20 migration. Treated the same as
     * "contract" so historical notifications still route correctly.
     */
    case "contract":
    case "document":
      return `${ROUTES.INVESTMENTS.CONTRACTS}?document_uuid=${uuid}`;
    default:
      return null;
  }
};
